import L from 'leaflet'
import rulerControler from '../leaflet-controls/ruler-controler'
export default function () {
  this.map._container.focus()
  if (this.map.customControls.hasOwnProperty('ruler')) return;
  if (this.map.customControls.hasOwnProperty('square')) {
    this.map.removeControl(this.map.customControls.square)
  }
  const rulerControl = rulerControler.extend({
    _currentIndex: null,
    _clicked: function (event) {
      if (this._currentIndex === null) {
        const lineSegmentLayer = L.featureGroup().addTo(this._allLayers)

        lineSegmentLayer.on('remove', (event) => {
          this._map.removeControl(event.target.options.control)
          this._allLayers.removeLayer(lineSegmentLayer)
        })
        lineSegmentLayer.on('mouseover', this._segmentHover, this)
        lineSegmentLayer.on('mouseout', this._segmentHover, this)
        lineSegmentLayer.segmentHover = this._segmentHover.bind(this)

        const divCircle = L.divIcon({ className: 'cross-point', iconSize: [32, 32], iconAnchor: [16, 16]})
        const marker = L.marker(event.latlng, {
          icon: divCircle,
          draggable: true,
          keyboard: false,
          key: 'startPoint'
        }).addTo(lineSegmentLayer)

        lineSegmentLayer.options.startPointId = marker._leaflet_id

        marker.getElement().classList.add('shadow')
        marker.on('move', this._moved.bind(this))

        this._currentIndex = this._allLayers.getLayers().length - 1
      } else {
        const lineSegmentLayer = this._allLayers.getLayers()[this._currentIndex]
        const divCircle = L.divIcon({ className: 'cross-point', iconSize: [32, 32], iconAnchor: [16, 16]})

        const marker = L.marker(event.latlng, {
          icon: divCircle,
          draggable: true,
          keyboard: false,
          key: 'finishPoint'
        }).addTo(lineSegmentLayer)

        lineSegmentLayer.options.finishPointId = marker._leaflet_id

        marker.getElement().classList.add('shadow')
        marker.getElement().style.setProperty('--pseudo-backgroundcolor', this.options.defaultColor)
        marker.on('move', this._moved.bind(this))

        this._currentIndex = null
        this._createControl(lineSegmentLayer)
        this._findInfo(lineSegmentLayer)
      }
    },
    _mapMousemoving: function (event) {
      if (this._currentIndex !== null) {
        const lineSegmentLayer = this._allLayers.getLayers()[this._currentIndex]
        if (lineSegmentLayer.options.lineId) {
          lineSegmentLayer.getLayer(lineSegmentLayer.options.lineId).setLatLngs([
            lineSegmentLayer.getLayer(lineSegmentLayer.options.startPointId).getLatLng(),
            event.latlng
          ])
        } else {
          const line = L.polyline([
            lineSegmentLayer.getLayer(lineSegmentLayer.options.startPointId).getLatLng(),
            event.latlng
          ], { dashArray: '3, 6', color: this.options.defaultColor, weight: 2 }).addTo(lineSegmentLayer)

          lineSegmentLayer.options.lineId = line._leaflet_id
          line.getElement().classList.add('shadow')
        }
      }
    },
    _segmentHover: function (event) {
      this._allLayers.eachLayer(layer => {
        if (event.type === 'mouseout' || layer === event.target) {
          layer.eachLayer(subLayer => {
            if (subLayer.setStyle) {
              subLayer.setStyle({ color: this.options.defaultColor })
            } else if (subLayer.getElement) {
              subLayer.getElement().style.setProperty('--pseudo-backgroundcolor', this.options.defaultColor)
            }
          })

          if (layer.options.control) {
            layer.options.control.updateColor(this.options.defaultColor)
          }
        } else {
          layer.eachLayer(subLayer => {
            if (subLayer.setStyle) {
              subLayer.setStyle({ color: this.options.inactiveColor })
            } else if (subLayer.getElement) {
              subLayer.getElement().style.setProperty('--pseudo-backgroundcolor', this.options.inactiveColor)
            }
          })

          if (layer.options.control) {
            layer.options.control.updateColor(this.options.inactiveColor)
          }
        }
      })
    },
    _moved: function (event) {
      this._allLayers.eachLayer(segment => {
        if (!segment.hasLayer(event.target)) return;

        if (event.target.options.key === 'startPoint') {
          segment.getLayer(segment.options.lineId).setLatLngs([
            event.latlng,
            segment.getLayer(segment.options.finishPointId).getLatLng(),
          ])
        } else {
          segment.getLayer(segment.options.lineId).setLatLngs([
            segment.getLayer(segment.options.startPointId).getLatLng(),
            event.latlng
          ])
        }

        this._findInfo(segment)
      })
    },
    _findInfo: function (segment) {
      if (!segment.options.control || !segment.options.lineId) return;

      const currentConfig = this._map.options.mapConfig
      const coordinates = segment.getLayer(segment.options.lineId).getLatLngs().map(coord =>
        this.changeCoordinates(coord, currentConfig)
      )

      const value = this._conversionToScale(this._distance(coordinates), currentConfig)
      segment.options.control.updateText(value + ' m')
    },
    _distance: function (coordinates) {
      return Math.sqrt(Math.pow((coordinates[1].lat - coordinates[0].lat), 2) + Math.pow(coordinates[1].lng - coordinates[0].lng, 2))
    },
    _conversionToScale: function (distance, { pointsPerMeter }) {
      return (distance / pointsPerMeter).toFixed(2)
    }
  })

  const ruler = new rulerControl({
    id: 'ruler',
    vue: this,
    defaultColor: '#18FFFF',
    inactiveColor: 'grey'
  })

  ruler.addTo(this.map)
}